var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConfirmCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#71bc68",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    strokeDasharray: 60,
    strokeDashoffset: 60,
    d: "M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "stroke-dashoffset",
    dur: "0.7s",
    values: "60;0"
  })), /*#__PURE__*/React.createElement("path", {
    strokeDasharray: 14,
    strokeDashoffset: 14,
    d: "M8 12L11 15L16 10"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "stroke-dashoffset",
    begin: "0.6s",
    dur: "0.2s",
    values: "14;0"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmCircle);
export default __webpack_public_path__ + "static/media/confirmCircle.245b839400b280ab721238d5c6a611d7.svg";
export { ForwardRef as ReactComponent };